import { Link } from 'react-router-dom';
import { parseIcon } from '@gov-nx/component/common';
import { useCmsExternalServiceModalLoader } from '@gov-nx/core/service';
import {
	isSmartForm,
	LinkParametersFormContextProvider,
	SmartFormContextProvider,
} from '@gov-nx/module/service';
import { useCmsUrlPath } from '@gov-nx/store';
import {
	Button,
	ButtonGroupLayout,
	DataTable,
	Dialog,
	Icon,
	LayoutGap,
} from '@gov-nx/ui/web';
import { useSearchParamsOperations } from '@gov-nx/web';
import { FavoriteToggle } from '../Favorite/FavoriteToggle';
import { MarkdownRender } from '../Markdown/MarkdownRender';
import { CmsLinkParametersForm } from './CmsLinkParametersForm';
import { SmartForm } from './SmartForm';

export const CmsExternalServiceListener = () => {
	const { deleteParam } = useSearchParamsOperations();
	const { baseCmsUrlPath } = useCmsUrlPath();
	const { id, externalService, isServiceSmartForm, onModalClose } =
		useCmsExternalServiceModalLoader({
			onAfterClose: () => deleteParam('formId'),
		});

	if (id && externalService) {
		const parsedIcon = externalService.icon?.icon
			? parseIcon(externalService.icon.icon)
			: null;
		return (
			<Dialog
				isOpen={true}
				blockBackdropClose={isServiceSmartForm}
				onClose={onModalClose}
				icon={
					externalService.icon?.file ? (
						<img
							src={baseCmsUrlPath + externalService.icon?.file}
							alt=""
							className="gov-icon object-contain"
							data-size="5xl"
						/>
					) : (
						<Icon
							name={parsedIcon?.name as never}
							type={parsedIcon?.type as never}
						/>
					)
				}
				title={<h3>{externalService.name}</h3>}
				accessibleCloseLabel="Zavřít okno s externím službou">
				<LayoutGap gap="m">
					<FavoriteToggle
						withLabel={true}
						code={externalService.code}
						name={externalService.name}
						size="l"
					/>
					<MarkdownRender>{externalService.description}</MarkdownRender>
					<DataTable
						customClasses="text-(--text-secondary)"
						responsive>
						<tbody>
							{externalService.parameters.map((parameter) => (
								<tr key={parameter.id}>
									<td>{parameter.key}:</td>
									<td>
										<MarkdownRender
											activatePhoneNumbers
											applyClasses={{ paragraph: 'font-bold!' }}
											disableWrapper>
											{parameter.value}
										</MarkdownRender>
									</td>
								</tr>
							))}
						</tbody>
					</DataTable>
					{externalService.links.map((link) => {
						if (isSmartForm(link)) {
							return (
								<SmartFormContextProvider
									link={link}
									nazev={externalService.name}
									key={link.link}>
									<SmartForm />
								</SmartFormContextProvider>
							);
						}

						if (link.linkParameters?.length) {
							return (
								<LinkParametersFormContextProvider
									key={link.id}
									link={link}
									parameters={link.linkParameters}>
									<CmsLinkParametersForm />
								</LinkParametersFormContextProvider>
							);
						}

						return (
							<ButtonGroupLayout>
								<Button
									key={link.id}
									type={link.properties.type}
									color={link.properties.color}
									aria-label={link.label}
									expandedMobile={true}
									iconEnd={
										<Icon
											type="components"
											name="box-arrow-up-right"
										/>
									}
									asChild>
									<Link
										target="_blank"
										to={link.link}>
										{link.label}
									</Link>
								</Button>
							</ButtonGroupLayout>
						);
					})}
				</LayoutGap>
			</Dialog>
		);
	}

	return null;
};
